// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-loader {
  width: 100%;
  background-color: #f0f0f0;
  min-height: 100px;
}

.skeleton-row {
  display: flex;
  margin-bottom: 10px;
}

.skeleton-cell {
  height: 60px;
  background-color: #e0e0e0;
  margin-right: 10px;
  border-radius: 4px;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNrZWxldG9uLWxvYWRlci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQUE7RUFDQSx5QkFBQTtFQUNBLGlCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7RUFDQSx5QkFBQTtFQUNBLGtCQUFBO0VBQ0Esa0JBQUE7RUFDQSxnQ0FBQTtBQUNGOztBQUVBO0VBQ0U7SUFBSyxZQUFBO0VBRUw7RUFEQTtJQUFNLFVBQUE7RUFJTjtFQUhBO0lBQU8sWUFBQTtFQU1QO0FBQ0YiLCJmaWxlIjoic2tlbGV0b24tbG9hZGVyLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrZWxldG9uLWxvYWRlciB7XG4gIHdpZHRoOiAxMDAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjBmMGYwO1xuICBtaW4taGVpZ2h0OiAxMDBweDtcbn1cblxuLnNrZWxldG9uLXJvdyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG59XG5cbi5za2VsZXRvbi1jZWxsIHtcbiAgaGVpZ2h0OiA2MHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTBlMGUwO1xuICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgYW5pbWF0aW9uOiBsb2FkaW5nIDEuNXMgaW5maW5pdGU7XG59XG5cbkBrZXlmcmFtZXMgbG9hZGluZyB7XG4gIDAlIHsgb3BhY2l0eTogMC42OyB9XG4gIDUwJSB7IG9wYWNpdHk6IDE7IH1cbiAgMTAwJSB7IG9wYWNpdHk6IDAuNjsgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-loader/skeleton-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE;IAAK,YAAA;EAEL;EADA;IAAM,UAAA;EAIN;EAHA;IAAO,YAAA;EAMP;AACF;AACA,4iCAA4iC","sourcesContent":[".skeleton-loader {\n  width: 100%;\n  background-color: #f0f0f0;\n  min-height: 100px;\n}\n\n.skeleton-row {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.skeleton-cell {\n  height: 60px;\n  background-color: #e0e0e0;\n  margin-right: 10px;\n  border-radius: 4px;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% { opacity: 0.6; }\n  50% { opacity: 1; }\n  100% { opacity: 0.6; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
